/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useState,
  useEffect,
} from 'react';

import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Modal } from "react-bootstrap";
import { useFormik } from 'formik';

import RenderError from '../../utils/RenderError';

import {
  completeUserProfile,
} from "app/services/auth";

interface CompleteProfileProps {
  isOpen: boolean;
  onClosed: () => void;
  onCompleted: () => void;
}

const CompleteProfile = ({ isOpen, onClosed, onCompleted }: CompleteProfileProps) => {
  const { auth } = useSelector((state: any) => ({
    auth: state.auth,
  }), shallowEqual);
  const dispatch = useDispatch();

  const [open, setOpen] = useState<any>(false);
  const [errors, setErrors] = useState<any>([]);

  const close = () => {
    setOpen(false);
    onClosed && onClosed();
  }

  useEffect(() => {
    if (isOpen === true) {
      setOpen(true);
      setErrors([]);
      formik.resetForm();
    } else {
      close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const formik = useFormik<any>({
    initialValues: {
      name: '',
      email: '',
    },
    validateOnMount: true,
    validate: (values) => {
      const errors: any = {};

      if (!values.name || values.name.trim() === '') {
        errors.name = 'Nome é obrigatório';
      }

      if (!values.email || values.email.trim() === '') {
        errors.email = 'E-mail é obrigatório';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = 'E-mail inválido';
      }

      return errors;
    },
    onSubmit: (values) => {
      setErrors([]);
      console.log('values', values);
      dispatch<any>(completeUserProfile(values.name, values.email, true)).then((response: any) => {
        onCompleted();
        close();
      })
        .catch(value => {
          setErrors(value);
        });
    },
  });

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        show={open}
        onHide={() => {}}
        dialogClassName="custom-modal mw-600px"
        className="bg-black bg-opacity-75"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg" className="py-1 flex-root d-flex justify-content-center">
            <h2 className="fd-uppercase">Complete seu perfil</h2>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center">
            <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10">
              <div className="w-md-400px">
                <div className="text-center mb-8">
                  <h1 className="text-dark fw-bolder mb-3">Bem-vindo!</h1>
                  <div className="text-gray-500 fw-semibold fs-6">
                    Para continuar, precisamos de algumas informações básicas
                  </div>
                </div>

                <form
                  className="form"
                  id="complete-profile-form"
                  onSubmit={formik.handleSubmit}
                  noValidate
                >
                  <div className='d-flex flex-column fv-row mb-8'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className='required'>Nome completo</span>
                    </label>

                    <input
                      type='text'
                      className='form-control bg-transparent'
                      placeholder='Digite seu nome completo'
                      autoComplete="name"
                      {...formik.getFieldProps('name')}
                    />

                    {formik.touched.name && formik.errors.name && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger mt-2'>{formik.errors.name as string}</div>
                      </div>
                    )}

                    {errors && <RenderError error={errors['name']} />}
                  </div>

                  <div className='d-flex flex-column fv-row mb-8'>
                    <label className='d-flex align-items-center fs-6 fw-bold form-label mb-2'>
                      <span className='required'>E-mail</span>
                    </label>

                    <input
                      type='email'
                      className='form-control bg-transparent'
                      placeholder='Digite seu e-mail'
                      autoComplete="email"
                      {...formik.getFieldProps('email')}
                    />

                    {formik.touched.email && formik.errors.email && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger mt-2'>{formik.errors.email as string}</div>
                      </div>
                    )}

                    {errors && <RenderError error={errors['email']} />}
                  </div>

                  <div className="d-grid mb-10">
                    <button
                      type='submit'
                      className='btn btn-lg btn-primary'
                      disabled={auth.actionLoading || !formik.isValid}
                    >
                      {!auth.actionLoading && <>
                        Continuar
                      </>}
                      {auth.actionLoading && <span className="indicator-label">
                        Carregando... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>}
                    </button>
                  </div>
                </form>

                <div className="fv-row">
                  <span className="form-check-label fw-semibold text-gray-700 fs-base text-center d-block">
                    Essas informações são necessárias para melhorar sua experiência no app
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CompleteProfile;
